import { render } from "./oaExamineTable.vue?vue&type=template&id=25770547&scoped=true"
import script from "./oaExamineTable.vue?vue&type=script&lang=js"
export * from "./oaExamineTable.vue?vue&type=script&lang=js"

import "./oaExamineTable.vue?vue&type=style&index=0&id=25770547&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-25770547"]])

export default __exports__